import { CountryList } from '../components/AttestationSection/AttestationSection.content';

export const getCountryCodeByPhoneCode = (
  phoneCode: string,
): string | undefined => {
  const normalizedPhoneCode = phoneCode.startsWith('+')
    ? phoneCode.slice(1)
    : phoneCode;
  const country = CountryList.find(
    (item) => item.phone === normalizedPhoneCode,
  );
  return country ? country.code.toLowerCase() : undefined;
};
